<template>
    <div class="room-structure-container">
        <el-row :gutter="20">
            <el-col :span="4">
                <floor-unit-tree ref="floorUnitTree" @switchFloorUnit="switchFloorUnit"/>
            </el-col>
            <el-col :span="20">
                <el-card v-show="false" class="room-list-card">
                    <el-row :gutter="10">
                        <el-col v-for="(room, index) in roomStructureInfo.rooms" :key="index" :xs="12" :sm="8" :md="6"
                                :lg="4"
                                :xl="3" class="room-item">

                            <div class="room-card" :style="{ 'background-color': getBgColor(room) }"
                                 @dblclick="toSimplifyAcceptance(room)">
                                <div class="room-number">{{ room.floorNum }}-{{ room.unitNum }}-{{ room.roomNum }}</div>
                                <div class="room-state">{{ room.stateName }}</div>
                                <div class="room-owner">{{ room.ownerName || $t('roomStructure.noOwner') }}</div>
                                <div class="room-debt">
                                    <span>{{ $t('roomStructure.owe') }}</span>：{{ room.oweAmount }}
                                    <span>{{ $t('roomStructure.yuan') }}</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>

                <el-card class="room-list-card">
                    <div style="width: 100%;margin-bottom: 10px;">
                        <el-select v-model="filtValue" placeholder="请选择"
                                   style="width: 100px;float: left;margin-right: 40px"
                                   size="small"
                                   @change="filtRoom()">
                            <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <div style="display: flex;padding-top: 5px">
                            <div style="display: flex;width: auto;align-items: center;margin-right: 32px;">
                                <div style="background-color: #DE743F;width: 20px; height:14px;margin-right: 10px;"
                                     class="flag-card">
                                </div>
                                <div style="font-size: 14px">即将到期</div>
                            </div>
                            <div style="display: flex;width: auto;align-items: center;margin-right: 32px;">
                                <div style="background-color: #C75038;width: 20px; height:14px;margin-right: 10px;"
                                     class="flag-card">
                                </div>
                                <div style="font-size: 14px">已欠费</div>
                            </div>
                            <div style="display: flex;width: auto;align-items: center;margin-right: 32px;">
                                <div style="background-color: #8F776B;width: 20px; height:14px;margin-right: 10px;"
                                     class="flag-card">
                                </div>
                                <div style="font-size: 14px">空闲</div>
                            </div>
                            <div style="display: flex;width: auto;align-items: center;margin-right: 32px;">
                                <div style="background-color: #538C9E;width: 20px; height:14px;margin-right: 10px;"
                                     class="flag-card">
                                </div>
                                <div style="font-size: 14px">已出租</div>
                            </div>
                            <div style="display: flex;width: auto;align-items: center;margin-right: 32px;">
                                <div style="background-color: #7A996E;width: 20px; height:14px;margin-right: 10px;"
                                     class="flag-card">
                                </div>
                                <div style="font-size: 14px">装修中</div>
                            </div>
                        </div>


                        <!--                        <div style="background-color: #C75038;" class="flag-card">-->
                        <!--                            已欠费-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #8F776B;" class="flag-card">-->
                        <!--                            空闲-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #1296db;" class="flag-card">-->
                        <!--                            已入住-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #4C8CDE;" class="flag-card">-->
                        <!--                            已交房-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #085DC9;" class="flag-card">-->
                        <!--                            已装修-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #9DBFEA;" class="flag-card">-->
                        <!--                            未入住-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #538C9E;" class="flag-card">-->
                        <!--                            已出租-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #1053A8;" class="flag-card">-->
                        <!--                            已售-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #4E79AF;" class="flag-card">-->
                        <!--                            空闲-->
                        <!--                        </div>-->
                        <!--                        <div style="background-color: #7A996E;" class="flag-card">-->
                        <!--                            装修中-->
                        <!--                        </div>-->
                    </div>


                    <div v-for="(val, key, index) in roomStructureInfo.parkRooms" :key="index">
                        <div class="floor-title">{{ key }}</div>
                        <el-row :gutter="10" class="floor-row">
                            <el-col v-for="(room, index) in val" :key="index" :xs="12" :sm="8" :md="6" :lg="4" :xl="3"
                                    class="room-item">
                                <div class="room-card" :style="{ 'background-color': getBgColor(room) }"
                                     @dblclick="toSimplifyAcceptance(room)">
                                    <div class="room-number">{{ room.floorNum }}-{{ room.unitNum }}-{{ room.roomNum }}
                                    </div>
                                    <div class="room-state">
                                        {{ room.ownerName || $t('roomStructure.noOwner') }}
                                    </div>
                                    <!--                                    <div class="room-owner">{{ room.ownerName || $t('roomStructure.noOwner') }}</div>-->
                                    <div class="room-debt" v-if="room.oweAmount != '0.00'">
                                        <span>{{ $t('roomStructure.owe') }}</span>：{{ room.oweAmount }}
                                        <span>{{ $t('roomStructure.yuan') }}</span>
                                    </div>
                                    <div class="room-debt" style="opacity: 0" v-else>
                                        1
                                    </div>

                                    <div v-if="room.oweAmount > 0">
                                        <img class="room-card1" src="/img/yiqianfei.png"/>
                                    </div>

                                    <div v-else-if="room.state === '0001'">
                                        <img class="room-card1" src="/img/jjdq.png"/>
                                    </div>

                                    <div v-else-if="!room.ownerName">
                                        <img class="room-card1" src="/img/kongxian.png"/>
                                    </div>

                                    <div v-else-if="room.state === '2006' || room.state === '2001'">
                                        <img class="room-card2" src="/img/yaoshi.png"/>
                                    </div>

                                    <div v-else-if="room.state === '2009'">
                                        <img class="room-card2" src="/img/zhuangxiu.png"/>
                                    </div>

                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import floorUnitTree from '@/components/room/floorUnitTree'
import {listRoomStructure} from '@/api/room/roomStructureApi'
import {getCommunityId} from '@/api/community/communityApi'

export default {
    name: 'RoomStructureList',
    components: {
        floorUnitTree
    },
    data() {
        return {
            roomStructureInfo: {
                rooms: [],
                parkRooms: {},
                layerRoomCount: 4
            },
            communityId: '',
            options: [{
                value: '-1',
                label: '全部'
            }, {
                value: '0001',
                label: '即将到期'
                // }, {
                //     value: '2001',
                //     label: '已入住'
                // }, {
                //     value: '2003',
                //     label: '已交房'
                // }, {
                //     value: '2005',
                //     label: '已装修'
                // }, {
                //     value: '2004',
                //     label: '未入住'
            }, {
                value: '2006',
                label: '已出租'
                // }, {
                //     value: '2007',
                //     label: '已售'
            }, {
                value: '2008',
                label: '空闲'
            }, {
                value: '2009',
                label: '装修中'
            }, {
                value: 'owe',
                label: '已欠费'
            }],
            filtValue: '-1',
            unitId: '',
            floorId: '',
        }
    },
    created() {
        this.communityId = getCommunityId()
        setTimeout(() => {
            this.$refs.floorUnitTree.selectFirstUnit()
        }, 1500)
    },
    methods: {
        async filtRoom() {
            this.roomStructureInfo.rooms = []
            this.roomStructureInfo.parkRooms = {}

            try {
                const params = {
                    page: 1,
                    row: 100,
                    unitId: this.floorId !== '' ? '' : this.unitId,
                    floorId: this.floorId,
                    communityId: this.communityId,
                    state: this.filtValue === 'owe' ? '-1' : this.filtValue
                }

                const {data} = await listRoomStructure(params)
                this.roomStructureInfo.rooms = this.filtValue === 'owe'
                    ? data.filter(item => item.oweAmount > 0)
                    : data
                this.supportPark()
            } catch (error) {
                console.error('Failed to load rooms:', error)
            }
        },
        handleSwitchUnit(params) {
            this.unitId = params.unitId;
            this.loadRooms(params.unitId)
        },
        switchFloorUnit(data) {
            console.log('777--- ' + JSON.stringify(data))
            // if (!data.unitId) {
            //     return
            // }
            //  this.unitId = data.unitId;
            //  this.loadRooms(data.unitId)
            this.unitId = data.unitId;
            this.floorId = data.floorId;
            this.loadRooms(data.unitId)
        },
        async loadRooms(unitId) {
            this.roomStructureInfo.rooms = []
            this.roomStructureInfo.parkRooms = {}

            try {
                const params = {
                    page: 1,
                    row: 100,
                    unitId: this.floorId !== '' ? '' : unitId,
                    floorId: this.floorId,
                    communityId: this.communityId,
                    state: this.filtValue === 'owe' ? '-1' : this.filtValue
                }
                console.log('666666--- ' + JSON.stringify(params))
                const {data} = await listRoomStructure(params)
                this.roomStructureInfo.rooms = this.filtValue === 'owe'
                    ? data.filter(item => item.oweAmount > 0)
                    : data
                this.supportPark()
            } catch (error) {
                console.error('Failed to load rooms:', error)
            }
        },
        getBgColor(room) {
            if (room.state === '0001') {//一个月内到期
                return "#DE743F"
            }
            if (room.oweAmount > 0) {
                return "#C75038"
            }
            if (!room.ownerName) {
                return "#8F776B"
            }
            if (room.state === '2001') {
                return '#538C9E'
            }
            if (room.state === '2003') {
                return '#4C8CDE'
            }
            if (room.state === '2005') {
                return '#085DC9'
            }
            if (room.state === '2004') {
                return '#9DBFEA'
            }
            if (room.state === '2006') {
                return '#538C9E'
            }
            if (room.state === '2007') {
                return '#1053A8'
            }
            if (room.state === '2008') {
                return '#4E79AF'
            }
            if (room.state === '2009') {
                return '#7A996E'
            }
            return "#1296db"
        },
        toSimplifyAcceptance(room) {
            this.$router.push('/pages/property/simplifyAcceptance?tab=业务受理&searchType=1&searchValue=' + `${room.floorNum}-${room.unitNum}-${room.roomNum}`)
        },
        supportPark() {
            const parkRooms = this.roomStructureInfo.parkRooms
            if (!this.roomStructureInfo.rooms || this.roomStructureInfo.rooms.length < 1) {
                return
            }

            this.roomStructureInfo.rooms.forEach(item => {
                if (!parkRooms[item.layer]) {
                    parkRooms[item.layer] = []
                }
                parkRooms[item.layer].push(item)
            })

            this.roomStructureInfo.parkRooms = parkRooms
            if (Object.keys(parkRooms).length > 0) {
                this.roomStructureInfo.layerRoomCount = parkRooms[Object.keys(parkRooms)[0]].length
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.room-structure-container {
    padding: 20px;
    height: 100%;

    .room-list-card {
        margin-bottom: 20px;
        min-height: calc(100vh - 120px);

        .flag-card {
            float: left;
            width: auto;
            padding-left: 4px;
            padding-right: 4px;
            border-radius: 4px;
            margin-left: 10px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: white;
        }

        .floor-title {
            font-size: 16px;
            font-weight: bold;
            padding: 10px 0;
        }

        .floor-row {
            margin-bottom: 20px;
        }

        .room-item {
            margin-bottom: 13px;
        }

        .room-card {
            color: #fff;
            border-radius: 4px;
            padding: 12px;
            cursor: pointer;
            display: flex; /* 开启Flex */
            flex-direction: column; /* 垂直排列子元素 */
            transition: all 0.3s;
            height: 88px;

            &:hover {
                transform: translateY(-3px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .room-number {
                text-align: left;
                margin-bottom: 5px;
            }

            .room-state,
            .room-owner,
            .room-debt {
                margin-bottom: 3px;
                text-align: left;
                color: rgba(255, 255, 255, 0.7);
                font-size: 12px;
            }

            .room-card1 {
                margin-top: 4px;
                width: 100%;
            }

            .room-card2 {
                margin-top: auto;
                cursor: pointer;
                display: flex; /* 开启Flex */
                flex-direction: column; /* 垂直排列子元素 */
                width: 24px;
                text-align: left;
            }
        }
    }
}
</style>
